import { ChevronRight, CheckCircle, Eye, EyeOff, XCircle } from '@reverb-ui/icons-react';
import {
  Button,
  Box,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  InputGroup,
  InputRightElement,
  Text,
  VStack,
} from '@reverb-ui/react';
import React, {useState} from 'react';
import {Controller, useFormContext, useWatch} from 'react-hook-form';
import {CustomInput} from "../../components/custom-input";

export const FormNewPassword = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmedNewPassword, setShowConfirmedNewPassword] =
    useState(false);

  const formValues = useWatch({control})

  const validatePassword = {
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{6,}$/
  }

  const validateConfirmedPassword = {
    validate: {
      mustBeEqual: (newValue) => newValue === formValues.password
    }
  }

  return (
    <VStack spacing={16}>
      <VStack spacing={8} width="full">
        <FormControl>
          <FormLabel htmlFor="password" fontWeight="medium" fontSize="md">
            New password
          </FormLabel>
          <InputGroup>
            <Controller
              control={control}
              name="password"
              rules={validatePassword}
              render={({ field, formState }) => {
                return (
                  <CustomInput
                    type={showNewPassword ? 'text' : 'password'}
                    placeholder="Enter your new password"
                    name={field.name}
                    onChange={field.onChange}
                    value={field.value || ''}
                    onBlur={field.onBlur}
                    isValid={!errors.password && formValues.password}
                    isInvalid={errors.password}
                  />
                );
              }}
            />
            <InputRightElement width="4.5rem">
              <IconButton
                h="1.75rem"
                size="sm"
                aria-label="Click here to show password"
                icon={
                  showNewPassword ? (
                    <Eye color="gray.500" />
                  ) : (
                    <EyeOff color="gray.500" />
                  )
                }
                bg="white"
                onClick={() => setShowNewPassword(!showNewPassword)}
              />
            </InputRightElement>
          </InputGroup>
          <HStack py={2} alignItems="top">
            <Box pt={1}>
              {formValues.password && !!errors.password && (
                  <XCircle color="red.500" />
              )}

              {formValues.password && !errors.password && (
                  <CheckCircle color="green.300" />
              )}

            </Box>

            <Text
              flex={1}
              color="gray.700"
              fontSize="sm"
            >
              Your password must have at least 1 upper case, 1 lower case, 1 number and 6+ letters
            </Text>
          </HStack>
        </FormControl>
        <FormControl>
          <FormLabel
            htmlFor="confirmedPassword"
            fontWeight="medium"
            fontSize="md"
          >
            Let's double check
          </FormLabel>
          <InputGroup>
            <CustomInput
              placeholder="Re-enter your new password"
              size="md"
              variant="outline"
              isValid={!errors.confirmedPassword && formValues.confirmedPassword}
              type={showConfirmedNewPassword ? 'text' : 'password'}
              isInvalid={!!errors?.confirmedPassword}
              {...register('confirmedPassword', validateConfirmedPassword)}
            />
            <InputRightElement width="4.5rem">
              <IconButton
                h="1.75rem"
                size="sm"
                aria-label="Click here to show password"
                icon={
                  showConfirmedNewPassword ? (
                    <Eye color="gray.500" />
                  ) : (
                    <EyeOff color="gray.500" />
                  )
                }
                bg="white"
                onClick={() =>
                  setShowConfirmedNewPassword(!showConfirmedNewPassword)
                }
              />
            </InputRightElement>
          </InputGroup>
          <HStack>
            {errors.confirmedPassword && formValues.confirmedPassword && (
              <XCircle color="red.500" />
            )}

            {!errors.confirmedPassword && formValues.confirmedPassword && (
              <CheckCircle color="green.300" />
            )}

            <Text color="gray.700" fontSize="sm" py={2}>
              {errors.confirmedPassword && formValues.confirmedPassword && (
                "Your passwords don't match"
              )}

              {!formValues.confirmedPassword && (
                "Your passwords must match"
              )}

              {!errors.confirmedPassword && formValues.confirmedPassword && (
                "Your password match!"
              )}
            </Text>

          </HStack>
        </FormControl>
      </VStack>
      <Flex width="full" justifyContent="center">
        <Button
          size="lg"
          bg="blue.500"
          color="white"
          colorScheme="blue"
          rightIcon={<ChevronRight color="white" />}
          type="submit"
        >
          Save password
        </Button>
      </Flex>
    </VStack>
  );
};
